module.exports = __webpack_public_path__ + "static/media/03_quote_mobile.52cf6ca7.jpg";